// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "lightbox-" + {"641":"photoswipe","683":"photoswipe-css"}[chunkId] + ".js";
};